<template>
    <div class="container">
        <div class="content-box">
            <div class="element-wrapper pb-0">
                <div class="element-header">
                    <div class="row">
                        <div class="col-md-8 mr-auto">
                        <h3 class>Financeiro</h3>
                        </div>
                      <div class="col text-right">
                        <b-btn @click="exportarResumo">
                          <i class="fas fa-file-excel"></i>  Exportar
                        </b-btn>
                      </div>
                    </div>
                </div>

                <filtro :find="find"></filtro>

                <div>
                    <div v-if="mostrarResultadoBusca">
                        <div class="row mt-2">
                          <div class="col">
                            <b-card title="Totalizadores" v-if="!isVendedorMaster">
                              <table class="table table-condensed">
                                <thead>
                                  <th class="text-center">Clientes pagos</th>
                                  <th class="text-center">Valor Total</th>
                                  <th class="text-center">Taxa Emissão Cartão</th>
                                  <th class="text-center">Taxa Adesão</th>
                                  <th class="text-center">Total Negociação</th>
                                  <th class="text-center">Total Negociação Dinheiro</th>
                                  <th class="text-center">Negociação Drachei</th>
                                  <th class="text-center">Imposto Negociação</th>
                                  <th class="text-center">Negociação Empresa</th>
                                  <th class="text-center">Para Empresas</th>
                                  <th class="text-center">Em dinheiro</th>
                                  <th class="text-center">Para DrAchei</th>
                                  <th class="text-center">Impostos</th>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td class="text-right">{{clientePagos}}</td>
                                    <td class="text-right">{{totalVendido|money}}</td>
                                    <td class="text-right">{{valorTaxaEmissaoCartao|money}}</td>
                                    <td class="text-right">{{totalTaxaAdesao|money}}</td>
                                    <td class="text-right">{{vlTotalNegociacao|money}}</td>
                                    <td class="text-right">{{vlTotalNegociacaoDinheiro|money}}</td>
                                    <td class="text-right">{{vlTotalNegociacaoDrAchei|money}}</td>
                                    <td class="text-right">{{vlTotalNegociacaoImposto|money}}</td>
                                    <td class="text-right">{{vlTotalNegociacaoEmpresa|money}}</td>
                                    <td class="text-right">{{totalRepasseEmpresa|money}}</td>
                                    <td class="text-right">{{valorRecebidoEmDinheiro|money}}</td>
                                    <td class="text-right">{{grupoSin|money}}</td>
                                    <td class="text-right">{{imposto|money}}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </b-card>
                          </div>
                        </div>
                    </div>
                    <div>
                        <div class="row mt-3">
                          <div class="col">
                            <b-card title="Por Empresa">
                                <div class="table-responsive">
                                  <table class="table table-striped table-hover table-condensed">
                                    <thead>
                                        <tr>
                                            <th>Empresa</th>
                                            <th>Clientes Pagos</th>
                                            <th>Valor Total</th>
                                            <th>Taxa Emissão Cartão</th>
                                            <th>Taxa Adesão</th>
                                            <th>Total Negociação</th>
                                            <th>Total Negociação Dinheiro</th>
                                            <th>Negociação Drachei</th>
                                            <th>Imposto Negociação</th>
                                            <th>Negociação Empresa</th>
                                            <th>Para Empresas</th>
                                            <th>Em Dinheiro</th>
                                            <th>Para Dr.Achei</th>
                                            <th>Impostos</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="totalPorEmpresa in lista" :key="totalPorEmpresa._id">
                                            <td>{{totalPorEmpresa.empresa}}</td>
                                            <td>{{totalPorEmpresa.totalClientesPagos}}</td>
                                            <td>{{totalPorEmpresa.valorTotal|money}}</td>
                                            <td>{{(totalPorEmpresa.vlTotalEmissaoCartao || 0) |money}}</td>
                                            <td>{{(totalPorEmpresa.taxaAdesao || 0) |money}}</td>
                                            <td>{{(totalPorEmpresa.vlTotalNegociacao || 0) |money}}</td>
                                            <td>{{(totalPorEmpresa.vlTotalNegociacaoDinheiro || 0) |money}}</td>
                                            <td>{{(totalPorEmpresa.vlNegociacaoDrAchei || 0) |money}}</td>
                                            <td>{{(totalPorEmpresa.vlNegociacaoImposto || 0) |money}}</td>
                                            <td>{{(totalPorEmpresa.vlNegociacaoEmpresa || 0) |money}}</td>
                                            <td>{{(totalPorEmpresa.repasseEmpresa || 0)|money}}</td>
                                            <td>{{(totalPorEmpresa.valorPagoEmDinheiro || 0) |money}}</td>
                                            <td>{{(totalPorEmpresa.repasse || 0)|money}}</td>
                                            <td>{{totalPorEmpresa.imposto|money}}</td>
                                            <td>
                                              <b-dropdown variant="light" split class="m-2"
                                                toggle-class="splitBtn"
                                                @click="detalheTotal(totalPorEmpresa)">
                                                <template v-slot:button-content>
                                                  <i class="fas fa-search"></i> Faturas
                                                </template>
                                                <b-dropdown-item-btn @click="detalheEmpresa(totalPorEmpresa)">
                                                  <i class="fas fa-industry"></i> Detalhe por Empresa
                                                </b-dropdown-item-btn>
                                                <b-dropdown-item-btn @click="detalheFaturaAvulsaCartao(totalPorEmpresa)">
                                                  <i class="fas fa-address-card"></i> Taxa Cartão
                                                </b-dropdown-item-btn>
                                                <b-dropdown-item-btn @click="detalheFaturaAvulsaNegociacao(totalPorEmpresa)">
                                                  <i class="fas fa-file-signature"></i> Negociação
                                                </b-dropdown-item-btn>
                                              </b-dropdown>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                </div>
                            </b-card>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style type="text/css">
.splitBtn {
  margin-left: 0!important;
}
th:first-child, td:first-child
{
  position:sticky;
  left:0;
  background-color: #ffffff;
}
.table-responsive {
  overflow-x: auto !important;
}
</style>
<script>
import axios from 'axios';
import moment from 'moment';
import filtro from '@/components/financeiro/Filtro';

import _ from 'lodash';
export default {
    created (){
        this.find();
    },
    components: {
        filtro,
    },
    computed: {
        filtro() {
          return this.$store.getters.filtro;
        },
        isVendedorMaster () {
          return this.$store.getters.isVendedorMaster;
        },
        empresa () {
          return this.$store.getters.empresa || {}
        }
    },
    data(){
        return {
            //Inicio resumo
            clientePagos:0,
            totalVendido:0,
            totalTaxaAdesao: 0,
            vlTotalNegociacao: 0,
            vlTotalNegociacaoDinheiro: 0,
            vlTotalNegociacaoDrAchei: 0,
            vlTotalNegociacaoImposto: 0,
            vlTotalNegociacaoEmpresa: 0,
            valorTaxaEmissaoCartao: 0,
            grupoSin:0,
            repaseEmpresas:0,
            valorRecebidoEmDinheiro: 0,
            totalRepasseEmpresa: 0,
            baixaManual:0,
            imposto:0,
            exibirFiltro:0,
            mostrarFiltros:{},
            totalFatura:0,
            totalVencidas:0,
            faturasVencida:0,
            totalAguardando:0,
            faturaAguardando:0,
            lista: []
        }
    },
    methods:{
        async downloadExcel(){},
        mostrarFiltro(exibirFiltro){
            this.exibirFiltro=1;
            this.mostrarFiltros = exibirFiltro;
        },
        openTablePedido(){
            this.mostrarResultadoBusca=false;
            this.mostrarTablePedido=true;
            this.$store.dispatch("setLoadingTable", true);
            this.$root.$emit('bv::refresh::table', 'stablePedidos')
            this.$store.dispatch("setLoadingTable", false);
        },
        async find(){
            this.$store.dispatch("setLoading",true);
            this.mostrarTablePedido=false;
            this.$store.dispatch("setLoadingTable", true);
            this.mostrarResultadoBusca=false;

            try {
                if (this.isVendedorMaster) {
                  this.filtro.empresa = [];
                  this.filtro.empresa.push(this.empresa);
                }
                const resposta = await this.$store.dispatch('find');

                const resumo = resposta.data.totalizadores;
                this.lista = resposta.data.lista;
                this.clientePagos = Number(resumo.clientePagos);
                this.totalVendido=Number(resumo.valorTotal);
                this.totalTaxaAdesao = Number(resumo.valorTaxaAdesao);

                this.valorTaxaEmissaoCartao = Number(resumo.valorTaxaEmissaoCartao);
                this.vlTotalNegociacao = Number(resumo.vlTotalNegociacao);
                this.vlTotalNegociacaoDinheiro = Number(resumo.vlTotalNegociacaoDinheiro);
                this.vlTotalNegociacaoDrAchei = Number(resumo.vlTotalNegociacaoDrAchei);
                this.vlTotalNegociacaoImposto = Number(resumo.vlTotalNegociacaoImposto);
                this.vlTotalNegociacaoEmpresa = Number(resumo.vlTotalNegociacaoEmpresa);

                this.grupoSin=Number(resumo.repasse);
                this.repaseEmpresas=Number(resumo.repasseEmpresas);
                this.imposto=Number(resumo.imposto);
                this.valorRecebidoEmDinheiro = Number(resumo.valorRecebidoEmDinheiro);
                this.totalRepasseEmpresa = Number(resumo.totalRepasseEmpresa);
                this.mostrarResultadoBusca=true;
            } catch (error) {
                alert(error.message);
            } finally {
                this.$store.dispatch("setLoading",false);
            }

        },
        createdAtFormatter(value){
            if (value) {
                return moment(value).format("DD/MM/YYYY");
            }
            return ''
        },
        createdAtFormataMoney(value){
            return "R$ "+value.toFixed(2)
        },
        pedidos(ctx) {
            const filtro = _.cloneDeep(this.filtro);
            var exibir =[];
            filtro.limit = ctx.perPage;
            filtro.page = ctx.currentPage;
            this.currentPage = ctx.currentPage;
             if(filtro.empresa){
                  exibir.push({
                    name:"Empresa",
                    mostrar:filtro.empresa.name
                })
                filtro.empresa = filtro.empresa._id;
            }
            if(filtro.formasPagamento){
                filtro.formasPagamento  = filtro.formasPagamento.map(fp => fp.code);
                exibir.push({
                    name:"Forma Pagamento",
                    mostrar:filtro.formasPagamento
                })
            }
            if (filtro.statusPedido) {
                filtro.statusPedido = filtro.statusPedido.map(st => st.code);
                exibir.push({
                    name:"Status Pedido",
                    mostrar:filtro.statusPedido
                })
            }
            if(filtro.dataInicioPedido || filtro.dataFimPedido){
                filtro.dataInicioPedido=this.createdAtFormatter(filtro.dataInicioPedido)
                filtro.dataFimPedido=this.createdAtFormatter(filtro.dataFimPedido)
            }
            const promise =axios.get('/api/saude/global',{
                params: filtro
            });

            return promise.then(response => {
            let result = response.data;
             // eslint-disable-next-line
            console.log(result)
            this.totalRows = result.totalCount;
            const items = result.data;
            return items || []
            });
        },
        onRowSelected(items) {
            let pedido = items[0];
            this.$router.push({name: 'PedidoDetail', query:{id: pedido._id}});
        },
        getTextStatusPagamento(statusVindi) {
            switch (statusVindi) {
            case 'processing':
                return 'Processando pagamento'
            case 'failure':
                return 'Falha ao processar pagamento'
            case 'rejected':
                return 'Pagamento rejeitado'
            case 'waiting':
                return 'Aguardando pagamento'
            case 'success':
            case 'paid':
                return 'Pago'
            default:
                return statusVindi
            }
        },
        getTextFormaPagamento(formaPagamento) {
            switch (formaPagamento) {
            case 'cartaoCredito':
                return 'Cartão Crédito'
            default:
                return formaPagamento;
            }
        },
        async detalheTotal(totalPorEmpresa) {
            const name = encodeURIComponent(totalPorEmpresa.empresa)
            const response = await axios.get(`/api/juridica/?select=name%20_id&name=${name}`);
            const empresaFind = response.data[0];

            await this.$store.dispatch('clearFiltroFatura');
            let filtroFatura = this.$store.getters.filtroFatura;
            const filtroEmpresa = filtroFatura.empresa;
            if (!filtroEmpresa.find(e => e._id === empresaFind._id)) {
                filtroEmpresa.push(empresaFind);
            }
            filtroFatura.dataInicial = this.filtro.dataInicial;
            filtroFatura.dataFinal = this.filtro.dataFinal;

            await this.$store.dispatch('buildExibeFiltro', {fatura: true});

            this.$router.push({name: 'DetalhesFaturas'});
        },
        async detalheFaturaAvulsaCartao(totalPorEmpresa) {
          const name = encodeURIComponent(totalPorEmpresa.empresa)
          const response = await axios.get(`/api/juridica/?select=name%20_id&name=${name}`);
          const empresaFind = response.data[0];

          await this.$store.dispatch('clearFiltroFatura');
          let filtroFatura = this.$store.getters.filtroFatura;
          const filtroEmpresa = filtroFatura.empresa;
          if (!filtroEmpresa.find(e => e._id === empresaFind._id)) {
            filtroEmpresa.push(empresaFind);
          }
          filtroFatura.tipo = 'taxaEmissaoCartao';
          const statusPago = this.$store.getters.statusCobranca.find(sc => sc.code === 'paid');
          filtroFatura.statusCobranca = [];
          filtroFatura.statusCobranca.push(statusPago);

          filtroFatura.dataInicial = this.filtro.dataInicial;
          filtroFatura.dataFinal = this.filtro.dataFinal;

          await this.$store.dispatch('buildExibeFiltro', {fatura: true});

          this.$router.push({name: 'DetalhesFaturasAvulsa'});
        },
        async detalheFaturaAvulsaNegociacao(totalPorEmpresa) {
          const name = encodeURIComponent(totalPorEmpresa.empresa)
          const response = await axios.get(`/api/juridica/?select=name%20_id&name=${name}`);
          const empresaFind = response.data[0];

          await this.$store.dispatch('clearFiltroFatura');
          let filtroFatura = this.$store.getters.filtroFatura;
          const filtroEmpresa = filtroFatura.empresa;
          if (!filtroEmpresa.find(e => e._id === empresaFind._id)) {
            filtroEmpresa.push(empresaFind);
          }
          filtroFatura.tipo = 'negociacao';

          const statusPago = this.$store.getters.statusCobranca.find(sc => sc.code === 'paid');
          filtroFatura.statusCobranca = [];
          filtroFatura.statusCobranca.push(statusPago);

          filtroFatura.dataInicial = this.filtro.dataInicial;
          filtroFatura.dataFinal = this.filtro.dataFinal;

          await this.$store.dispatch('buildExibeFiltro', {fatura: true});

          this.$router.push({name: 'DetalhesFaturasAvulsa'});
        },
        async detalheEmpresa(totalPorEmpresa) {
          const name = encodeURIComponent(totalPorEmpresa.empresa)
          const response = await axios.get(`/api/juridica/?select=name%20_id&name=${name}`);
            const empresaFind = response.data[0];

            const filtroEmpresa = this.filtro.empresa;
            if (!filtroEmpresa.find(e => e._id === empresaFind._id)) {
                filtroEmpresa.push(empresaFind);
            }

            this.$router.push({name: 'DetalhesEmpresas'});
        },
        async exportarResumo() {
          this.$store.dispatch("setLoading", true);
          await this.$store.dispatch('findExcel');
          this.$store.dispatch("setLoading", false);
        }
    }
}
</script>

